import loadable from "@loadable/component";
import { FC } from "react";
import APIS from "../../constant/Endpoint";
import usePatchHook from "../../customHooks/usePatchHook";
import { queryClient } from "../../root.component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import StatusIcon from "../../Icons/StatusIcon";

const BlogListComponent = loadable(
  () => import("../../components/Posts/PostList") as unknown as Promise<FC>
);

export const BlogList = () => {
  const { mutateAsync, isLoading: isPatching } = usePatchHook({
    queryKey: ["blog-list-patch"],
  });

  const handlePublish = async (value: boolean, id: string) => {
    const url = `${APIS.BLOG_STATUS + id}/`;
    await mutateAsync({ url, formData: { is_published: value } });
    queryClient.invalidateQueries();
  };

  const handlePublic = async (value: boolean, id: string) => {
    const url = `${APIS.BLOG_STATUS + id}/`;
    await mutateAsync({ url, formData: { is_public: value } });
    queryClient.invalidateQueries();
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 uppercase font-extrabold items-center`}
      >
        <StatusIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Posts</span>
      </div>
      <BlogListComponent
        //@ts-ignore
        handlePublish={handlePublish}
        handlePublic={handlePublic}
        isPatching={isPatching}
      />
    </>
  );
};
